import { render, staticRenderFns } from "./customerType.vue?vue&type=template&id=fc9c6166"
import script from "./customerType.vue?vue&type=script&lang=js"
export * from "./customerType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports